module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.570eb838.570eb83.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/geetest-ui/fonts/MaterialIcons-Regular.570eb838.woff2
// module id = 461
// module chunks = 14